export enum ElectricityTariff {
  Single = 'single',
  Double = 'double',
}
